export const REAL_PROJECT_SLIDES = [
  { slide_id: "hero_pipework", label: "Precision pipework", desktop_image: "/projects/ashford-the-triangle/first-fix.webp", mobile_image: "/projects/fendall-street/risers.webp", published: true },
  { slide_id: "hero_heating", label: "Daikin heat pumps", desktop_image: "/projects/fendall-street/daikin-rooftop.webp", mobile_image: "/projects/fendall-street/risers.webp", published: true },
  { slide_id: "hero_water", label: "Heating distribution", desktop_image: "/projects/fendall-street/daikin-system.webp", mobile_image: "/projects/fendall-street/risers.webp", published: true },
];

export const useHeroSlidesEditor = (slides, onChange) => {
  const updateSlide = (slideId, field, value) => onChange(slides.map((slide) => slide.slide_id === slideId ? { ...slide, [field]: value } : slide));
  const addSlide = () => onChange([...slides, { slide_id: `hero_${crypto.randomUUID()}`, label: "New cover", desktop_image: "", mobile_image: "", published: false }]);
  const removeSlide = (slideId) => onChange(slides.filter((slide) => slide.slide_id !== slideId));
  const restoreSlides = () => onChange(REAL_PROJECT_SLIDES);
  const moveSlide = (fromIndex, toIndex) => {
    if (toIndex < 0 || toIndex >= slides.length) return;
    const reordered = [...slides];
    const [moved] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, moved);
    onChange(reordered);
  };
  return { addSlide, moveSlide, removeSlide, restoreSlides, updateSlide };
};